module.exports = __webpack_public_path__ + "img/sorghum.be5030ca.webp";